import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILiveMachineData, MarkerIconType } from 'interfaces/maps.interface';
import { PlaceTagValueType } from 'interfaces/vector.interface';

export interface ITagFilters {
	combiningOperator: 'AND' | 'OR';
	conditions: {
		baseCondition: {
			logicalOperator: 'EQUAL' | 'IN' | 'GREATER' | 'SMALLER';
			tag: {
				TagName: string;
				TagPropertyKey: string;
				value: {
					valueType: PlaceTagValueType;
					stringValues?: string[];
					boolValues?: boolean[];
					int64Values?: number[];
					int32Values?: number[];
					floatValues?: number[];
					// nsvPlaceIdValues?: ParentPlaceIdTag[];
					// overlappingPlaceValues?: OverlappingPlaceValue[];
				};
			};
		};
	}[];
}

interface InitialTelematicsState {
	activeAlertFilters: Set<MarkerIconType>;
	activeTagFilters: ITagFilters | Record<string, never>;
	liveMachinesData: Record<string, ILiveMachineData>;
	selectedLiveMachine: undefined | string;
}

const initialState: InitialTelematicsState = {
	activeAlertFilters: new Set(),
	activeTagFilters: {},
	liveMachinesData: {},
	selectedLiveMachine: undefined,
};

export const telematicsSlice = createSlice({
	name: 'telematics',
	initialState: initialState,
	reducers: {
		resetLiveMachinesData: (state) => {
			state.liveMachinesData = {};
		},
		removeLiveMachineData: (state, action: PayloadAction<string>) => {
			delete state.liveMachinesData[action.payload];
		},
		resetTelematicsStore: () => initialState,
		setActiveAlertFilters: (
			state,
			action: PayloadAction<Set<MarkerIconType>>,
		) => {
			state.activeAlertFilters = action.payload;
		},
		setActiveTagFilters: (
			state,
			action: PayloadAction<ITagFilters | Record<string, never>>,
		) => {
			state.activeTagFilters = action.payload;
		},
		setLiveMachinesData: (
			state,
			action: PayloadAction<Record<string, ILiveMachineData>>,
		) => {
			state.liveMachinesData = {
				...state.liveMachinesData,
				...action.payload,
			};
		},
		setSelectedLiveMachine: (state, action: PayloadAction<string>) => {
			state.selectedLiveMachine = action.payload;
		},
	},
});

export const {
	removeLiveMachineData,
	resetLiveMachinesData,
	resetTelematicsStore,
	setActiveAlertFilters,
	setActiveTagFilters,
	setLiveMachinesData,
	setSelectedLiveMachine,
} = telematicsSlice.actions;

export default telematicsSlice.reducer;
